/* import __COLOCATED_TEMPLATE__ from './condition-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();